import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import {ColumnsEdit} from "../../../../../../../types/models/column-table-edit";

const { INPUT, DATE, COMBO_BOX,DATE_DISABLE_NO_DAY, AUTO_COMPLETE, CURRENCY, NUMBER ,DATE_PRE ,DATE_ON ,DATE_DISABLE} = FIELD_TYPE;
const dataFieldsCV: ColumnsEdit = [
  {
    type:COMBO_BOX,
    label: "Loại công việc",
    name: "loaiCongViec",
    disable: false,
    expand: false,
    options: [
      { value: "1", label: "Công việc" },
      { value: "2", label: "Nghỉ thai sản" },
      { value: "3", label: "Nghỉ không lương" },

    ],
    rules: [{required: true, message: "Chưa nhập loại công việc"}],
  },
  {
    type: COMBO_BOX,
    label: "Phòng ban",
    name: "idPhongBan",
    disable: false,
    expand: false,
  },

  {
    type: COMBO_BOX,
    label: "Chức vụ",
    name: "idChucVu",
    disable: false,
    expand: false,
    rules: [{required: true, message: "Chưa nhập chức vụ"}],

  },
  // {
  //   type: COMBO_BOX,
  //   label: "Nhóm",
  //   name: "idNhomCongViec",
  //   disable: false,
  //   expand: false,
  //   rules: [{required: true, message: "Chưa nhập nhóm công việc"}],
  // },
  {
    type: INPUT,
    label: "Số hợp đồng",
    name: "soHopDong",
    disable: true,
    expand: false,
  },
  {
    type: COMBO_BOX,
    label: "Loại hợp đồng",
    name: "idLoaiHopDong",
    disable: false,
    expand: false,
  },
  {
    type: COMBO_BOX,
    label: "Số giờ/tuần",
    name: "soGioTrongTuan",
    disable: false,
    expand: false,
    rules: [{required: true, message: "Chưa nhập số giờ trên tuần"}],
  },

  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày bắt đầu HD",
    name: "ngayBatDau",
    disable: false,

    disableDate:false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    rules: [{required: true, message: "Chưa nhập ngày bắt đầu hợp đồng"}],
  },

  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày hết HD",
    name: "ngayHetHD",
    disable: false,
    disableDate:false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: INPUT,
    label: "Lý do",
    name: "lyDo",
    disable: false,
    expand: false,
  },
  {
    type: COMBO_BOX,
    label: "Địa chỉ làm việc",
    name: "diaChiLamViec",
    disable: false,
    expand: false,
  },
  
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
    disable: false,
    expand: false,
  },
];
const dataFieldsL: DataFormField[] = [
  {
    type: CURRENCY,
    label: "Lương đóng BHXH",
    name: "luongDongBHXH",
    disable: true,
    expand: false,
  },
  {
    type: COMBO_BOX,
    label: "Tham gia BHXH",
    name: "thamGiaBHXH",
    disable: false,
    expand: false,
    options: [
      { value: 0, label: "Không" },
      { value: 1, label: "Có" },
    ],
  },
  {
    type: CURRENCY,
    label: "Lương thử việc",
    name: "luongThuViec",
    disable: false,
    expand: false,

  },
  {
    type: CURRENCY,
    label: "Phụ cấp trách nhiệm",
    name: "phuCapTrachNhiem",
    disable: false,
    expand: false,
  },
  {
    type: CURRENCY,
    label: "Lương cơ bản",
    name: "luongCoBan",
    disable: false,
    expand: false,
  },

];
const dataFieldsTC: DataFormField[] = [
  {
    type:CURRENCY,
    label: "Hỗ trợ xăng xe đi lại",
    name: "hoTroXangXeDiLai",
    disable: false,
    expand: false,
  },
  {
    type: CURRENCY,
    label: "Hỗ trợ điện thoại",
    name: "hoTroDienThoai",
    disable: false,
    expand: false,
  },

  {
    type: CURRENCY,
    label: "Hỗ trợ trang phục",
    name: "hoTroTrangPhuc",
    disable: false,
    expand: false,

  },
  {
    type: CURRENCY,
    label: "Hỗ trợ chỗ ở",
    name: "hoTroChoO",
    disable: false,
    expand: false,
  },
  {
    type: CURRENCY,
    label: "Hỗ trợ ăn trưa",
    name: "hoTroAnTrua",
    disable: false,
    expand: false,
  },
  {
    type: CURRENCY,
    label: "Thưởng hiệu suất công việc",
    name: "thuongHieuSuat",
    disable: false,
    expand: false,
  },


];
const dataFieldsHTK: DataFormField[] = [
  {
    type: CURRENCY,
    label: "Hỗ trợ tiền thuê nhà",
    name: "hoTroTienThueNha",
    disable: false,
    expand: false,
  },
  {
    type: CURRENCY,
    label: "Hỗ trợ tiền đi lại",
    name: "hoTroTienDiLai",
    disable: false,
    expand: false,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Áp dụng từ ngày",
    name: "apDungTuNgay",
    disable: false,

    disableDate:false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Áp dụng đến ngày",
    name: "apDungDenNgay",
    disable: false,

    disableDate:false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
];
const dataFieldsLV: DataFormField[] = [
  {
    type: INPUT,
    label: "Số ngày làm việc",
    name: "soNgayLamViec",
    disable: false,
    rules: [
      {
        pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        message: "Chỉ cho phép nhập số",
      },
    ],
  },
  {
    type: INPUT,
    label: "Số ngày làm việc nội trú",
    name: "soNgayLamViecNoiTru",
    disable: false,
    rules: [
      {
        pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        message: "Chỉ cho phép nhập số",
      },
    ],
  },
  {
    type: INPUT,
    label: "Số ngày làm việc ngoại trú",
    name: "soNgayLamViecNgoaiTru",
    disable: false,
    rules: [
      {
        pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        message: "Chỉ cho phép nhập số",
      },
    ],
  },
];
export {dataFieldsHTK,dataFieldsCV,dataFieldsL,dataFieldsTC,dataFieldsLV};
